import 'vue-tsx-support/enable-check';
import { VNode } from 'vue';
import * as tsx from 'vue-tsx-support';
import './cellRenderTsx.less';
import './addRemoveRender.less';
import { CommonUtil } from '../../util/commonUtil';
import { Integer } from '../../types/base';

type Fn = (params: any) => boolean;

export interface CheckboxNumberStateI {
    onBlur?(params: any): void;
    onStep?(params: any): void;
    onCheck?(v: boolean, params: any);
    precision?: number;
    min?: Integer;
    max?: number;
    editable?: boolean | Fn;
}

const CheckboxNumberRender = tsx.componentFactory.create({
    methods: {
        onBlur() {
            let cellRendererFrameworkOpt: CheckboxNumberStateI =
                (this.params.colDef.cellRendererFrameworkOpt as CheckboxNumberStateI) || {};
            cellRendererFrameworkOpt.onBlur && cellRendererFrameworkOpt.onBlur(this.params);
        },
        onCheck(v: boolean) {
            let cellRendererFrameworkOpt: CheckboxNumberStateI =
                (this.params.colDef.cellRendererFrameworkOpt as CheckboxNumberStateI) || {};
            cellRendererFrameworkOpt.onCheck && cellRendererFrameworkOpt.onCheck(v, this.params);
        },
        // 改变颜色
        changeAuditColor(audit: string): string {
            //审核状态:-1未审核#6495ED   0审核#FFFFFF 优先级别1:#FFA500 已审核,优先级别不是1 #FF0000
            if (audit == '1') {
                return '#FFA500';
            }else if (audit == '99999') { //99999特殊标记，其他标记按audit状态渲染颜色，空数据列固定颜色不受审核状态影响
                return '#FFFB00';
            } else if (audit == '204') {
                return '#686868';
            }else if (audit == '-1') {
                return '#6495ED';
            } else if (audit == '0') {
                return '#FFFFFF';
            } else if (audit !== undefined && audit != '1') {
                return '#FF0000';
            } else {
                return '#6495ED';
            }
        },
    },
    created() {},
    render(h): VNode {
        let cellRendererFrameworkOpt: CheckboxNumberStateI = (this.params.colDef.cellRendererFrameworkOpt as CheckboxNumberStateI) || {};
        let { precision, max, min, editable } = cellRendererFrameworkOpt as any;
        if (!this.params.data[this.params.column.colDef.field]) {
            return <span />;
        }

        let renderEmptyText = h => {
            // 审核参数
            let { audits } = this.params.data[this.params.column.colDef.field];
            let value = this.params.data[this.params.column.colDef.field].value;
            let flag = this.params.data[this.params.column.colDef.field].flag;
            if(this.params.data[this.params.column.colDef.field].nullData){
                audits = '99999'
            }
            return (
                <span style={`color:${this.changeAuditColor(audits)}`}>
                    {/* {CommonUtil.isFieldEmpty(value) ? '' : CommonUtil.toFixed(value, precision || 0) + flag} */}
                    {value + flag}
                </span>
            );
        };
        return renderEmptyText(h);
    },
});
export default CheckboxNumberRender;
